import React, { useState } from "react";
import DashboardNavbar from "../components/layouts/dashboardNav";
import { Typography, Box } from "@mui/material";
import SmInput from "../components/smallComp/smInput";
import SmButton from "../components/smallComp/smButtton";
import { sendData } from "../configuration/firebase/firebaseMethod";





function BookingScreen() {
    const [customerBook, setCustomerBook] = useState({});

    const Book = () => {
        if (!customerBook.email) {
            alert("Email is required.");
            return
        }
        if (!customerBook.cnic || customerBook.cnic.length < 13) {
            alert("Enter Valid CNIC number ");
            return
        };
        if (!customerBook.creditNo) {
            alert("Enter Valid Credit Card  number ");
            return
        };

        console.log(customerBook);

        sendData(customerBook, 'customerBooking').then(() => {
            alert("Your Booking process successfully completed. Thanks")
        }).catch((err) => {
            console.log(err)
        })



    }



    return (
        <>
            <DashboardNavbar />
            <Box >
                <div class="album py-5 bg-dark" >
                    <div class="container">
                        <Typography variant="h2" sx={{ color: "white", padding: "20px" }}>For Booking Please Fill this form</Typography>
                        <Box sx={{ backgroundColor: "White", padding: "50px" }}>
                            <Box sx={{ padding: "10px",display:"flex",justifyContent:"center",alignItem:"center" }}>
                                <Box sx={{padding:"10px"}}>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, name: e.target.value })} type="text" label="Name" />
                                </Box>
                                <Box sx={{ padding: "10px" }}>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, fatherName: e.target.value })} type="text" label="Father Name" />
                                </Box>
                            </Box>
                            <Box sx={{ padding: "10px",display:"flex",justifyContent:"center",alignItem:"center"  }}>
                                <Box sx={{ padding: "10px" }}>
                                <SmInput onChange={(e) => setCustomerBook({ ...customerBook, cnic: e.target.value })} type="text" label="CNIC" />
                                </Box>
                            <Box sx={{ padding: "10px" }}>
                                <SmInput onChange={(e) => setCustomerBook({ ...customerBook, contact: e.target.value })} type="text" label="Contact" />
                            </Box>
                            </Box>
                            <Box sx={{ padding: "10px" }}>
                                <SmInput onChange={(e) => setCustomerBook({ ...customerBook, email: e.target.value })} type="text" label="Email" />
                            </Box>
                            <Box sx={{ padding: "10px" }}>
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>
                                    <Typography sx={{ padding: "5px" }}>Arrival Date</Typography>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, arrDate: e.target.value })} type="date" />
                                    <Typography sx={{ padding: "5px" }}>Departure Date</Typography>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, departDate: e.target.value })} type="date" />
                                </Box>
                                <Box sx={{ padding: "10px",display:"flex",justifyContent:"center",alignItem:"center"   }}>
                                    <Box sx={{padding:"10px"}}><SmInput onChange={(e) => setCustomerBook({ ...customerBook, persons: e.target.value })} type="text" label="No. of Persons" /></Box>
                                <Box sx={{ padding: "10px" }}>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, days: e.target.value })} type="text" label="No. of Days" />
                                </Box>
                                </Box>
                                <hr></hr>
                                <Typography variant="h5">Payment Method</Typography>

                                <Box sx={{ padding: "10px",display:"flex",justifyContent:"center",alignItem:"center"}}>
                                   <Box sx={{ padding: "10px" }}> <SmInput onChange={(e) => setCustomerBook({ ...customerBook, bankName: e.target.value })} type="text" label="Bank Name" /></Box>
                                <Box sx={{ padding: "10px" }}>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, creditNo: e.target.value })} type="text" label="Credit Card Number" />
                                </Box>
                                </Box>
                                <Box sx={{ padding: "10px" }}>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, cardCode: e.target.value })} type="password" label="Password" />
                                </Box>
                                <Box sx={{ padding: "10px" }}>
                                    <Typography sx={{padding:"10px"}}>Card Expiry Date</Typography>
                                    <SmInput onChange={(e) => setCustomerBook({ ...customerBook, expiryDate: e.target.value })} type="date" />
                                </Box>
                            </Box>
                            <Box>
                                <Box>
                                    <SmButton onClick={Book} label="Book" />
                                </Box>


                            </Box>
                        </Box>



                    </div>
                </div>
            </Box>
        </>
    )
}



export default BookingScreen;